
import React from 'react';

const FloatingElements = () => {
  // Removed animate-pulse for performance
  return (
    <>
      <div className="absolute top-20 left-10 w-2 h-2 bg-orange-400 rounded-full shadow-lg shadow-orange-400/50" />
      <div className="absolute top-40 right-20 w-1 h-1 bg-pink-400 rounded-full shadow-lg shadow-pink-400/50" />
      <div className="absolute bottom-20 left-20 w-1.5 h-1.5 bg-lime-400 rounded-full shadow-lg shadow-lime-400/50" />
      <div className="absolute top-60 right-40 w-1.5 h-1.5 bg-yellow-400 rounded-full shadow-lg shadow-yellow-400/50" />
      <div className="absolute bottom-40 right-10 w-1 h-1 bg-rose-400 rounded-full shadow-lg shadow-rose-400/50" />
    </>
  );
};

export default FloatingElements;
